export const ASSIGN_USERS_PERMISSIONS = "ASSIGN_USERS_PERMISSIONS";
export const RESET_USERS_PERMISSIONS = "RESET_USERS_PERMISSIONS";
